import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { getManagerAgentsAnalytics } from 'services/api/getManagerAgentAnalytics';

const DEFAULT_MANAGER_AGENTS_ANALYTICS = {
    timezone: '',
    activityByHour: {
        buckets: [],
        timezone: '',
    },
    agents: [],
};

export const useGetManagerAgentsAnalytics = () => {
    const { data, isLoading, isFetching, ...rest } = useQuery({
        queryKey: queryKeys.managerAgentsAnalytics,
        queryFn: getManagerAgentsAnalytics,
    });

    return {
        managerAgentsAnalytics: data ?? DEFAULT_MANAGER_AGENTS_ANALYTICS,
        isManagerAgentsAnalyticsLoading: isLoading,
        isManagerAgentsAnalyticsFetching: isFetching,
        ...rest,
    };
};
